(function ($) {

  $(function () {
    $('[data-scroll-button]').each(function() {
      const $button = $(this),
        $a = $button.find('a'),
        $parent = $button.closest('.mp-container'),
        $next = $parent.next('.mp-container')
      ;
      if ($next.length > 0) {
        const id = $next.attr('id');
        $a.attr('href', `#${id}`);
      }
    });
  });

})(jQuery);
